import { combineReducers } from "redux";
import routerReducer from "./router/reducer";
import productReducer from "./product/reducer";

const rootReducer = combineReducers({
  router: routerReducer,
  product: productReducer,
});

export default rootReducer;
